/* ===== VELORA v2 — Scripts ===== */

/* Reveal on scroll */
function initReveal() {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('v2-visible'); obs.unobserve(e.target); } });
  }, { threshold: 0.1 });
  document.querySelectorAll('.v2-reveal').forEach(el => obs.observe(el));
}

/* Galería PDP */
function initGaleria() {
  const principal = document.querySelector('.v2-galeria__principal img');
  if (!principal) return;
  document.querySelectorAll('.v2-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src || thumb.querySelector('img').src;
      const srcset = thumb.dataset.srcset || thumb.querySelector('img').srcset;
      principal.src = src;
      principal.srcset = srcset || '';
      document.querySelectorAll('.v2-thumb').forEach(t => t.classList.remove('v2-thumb--activa'));
      thumb.classList.add('v2-thumb--activa');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initReveal();
  initGaleria();
});
